/*
  Cart add-ons engine (2026-10-01): the "Complete your setup" tray.
  Rules and product data come from sections/cart-addons.liquid (one JSON block, printed on product, collection and cart
  pages and on any page where the cart has items). The tray is stateless: every render is derived from the
  cart contents + that data, so it works from any add path and needs no stored state except the dismiss flag.

  Hosts:
    <cart-drawer>            calls KabutoAddons.mount(container, { mode: 'drawer', onAdded }) and update(cart)
    <div data-addons="cart"> (sections/cart.liquid)     mounted automatically; reloads the page after an add
    <div data-addons="product" data-product-id="…">     (sections/product.liquid) mounted automatically
*/
(function () {
  if (window.KabutoAddons) return;

  var DISMISS_KEY = 'kb-addons-dismissed'; // + '-' + mode: each place (drawer, cart page) is dismissed on its own
  var ALLOWED_INLINE = { STRONG: 1, B: 1, EM: 1, I: 1 };

  function root(path) {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r + path;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function store(method, key, value) {
    try {
      if (method === 'get') return sessionStorage.getItem(key);
      if (method === 'set') sessionStorage.setItem(key, value);
      if (method === 'remove') sessionStorage.removeItem(key);
    } catch (e) {}
    return null;
  }
  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var out = Shopify.formatMoney(cents);
        if (out && out.indexOf('undefined') === -1) return out;
      }
    } catch (e) {}
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }
  // Readiness with bold/italic: keep only strong/b/em/i, no attributes.
  function cleanInline(html) {
    var box = document.createElement('template');
    box.innerHTML = html;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) return;
        if (child.nodeType !== 1 || !ALLOWED_INLINE[child.tagName]) { child.remove(); return; }
        while (child.attributes.length) child.removeAttribute(child.attributes[0].name);
        walk(child);
      });
    })(box.content);
    return box.innerHTML;
  }
  function track(cfg, name, payload) {
    if (!cfg || !cfg.track) return;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload); } catch (e) {}
  }

  // ---- data -------------------------------------------------------------------------------------------------
  var dataCache;
  function loadData() {
    if (dataCache === undefined) {
      var el = document.querySelector('script[data-cart-addons]');
      var data = null;
      if (el) { try { data = JSON.parse(el.textContent); } catch (e) {} }
      dataCache = data;
    }
    return Promise.resolve(dataCache);
  }

  // ---- rules ------------------------------------------------------------------------------------------------
  // Which groups apply to this cart, with their cards. Same-named groups merge; a product shows only once.
  // cart.items decide which groups apply; cart.also (product page: the real cart) only hides what is already bought.
  function compute(data, cart) {
    var inCart = {};
    var bought = {};
    var triggers = {};
    var excluded = {};
    var boxIds = [];
    (cart.also || []).forEach(function (item) { bought[item.product_id] = true; });
    cart.items.forEach(function (item) {
      inCart[item.product_id] = true;
      bought[item.product_id] = true;
      var inc = data.i && data.i[item.product_id];
      if (inc) {
        excluded[inc] = true;
        if (boxIds.indexOf(inc) === -1) boxIds.push(inc);
      }
    });
    // Rule-driven "In the box" items (Footer → Cart add-ons → In the box item), after the helmet's included shield.
    (data.b || []).forEach(function (b) {
      if (!b.w.some(function (id) { return inCart[id]; })) return;
      b.o.forEach(function (id) { if (data.p[id] && boxIds.indexOf(id) === -1) boxIds.push(id); });
    });
    var merged = [];
    var byName = {};
    data.g.forEach(function (g) {
      var hit = g.w.some(function (id) { return inCart[id]; });
      if (!hit) return;
      g.w.forEach(function (id) { if (inCart[id]) triggers[id] = true; });
      var key = g.n.toLowerCase();
      var m = byName[key];
      if (!m) {
        m = byName[key] = { id: g.id, name: g.n, note: g.t, limit: g.l, collapsed: g.c, url: g.u, items: [], has: {} };
        merged.push(m);
      }
      g.o.forEach(function (id) {
        var p = data.p[id];
        if (!p || !p.a || bought[id] || excluded[id] || m.has[id]) return;
        m.has[id] = true;
        m.items.push(id);
      });
    });
    var seen = {};
    merged.forEach(function (m) {
      m.items = m.items.filter(function (id) { if (seen[id]) return false; seen[id] = true; return true; });
    });
    merged = merged.filter(function (m) { return m.items.length; });
    return {
      groups: merged,
      box: boxIds.filter(function (id) { return data.p[id]; }),
      signature: Object.keys(triggers).sort().join(',')
    };
  }

  // ---- view -------------------------------------------------------------------------------------------------
  function Tray(el, opts) {
    this.el = el;
    this.mode = opts.mode;
    this.onAdded = opts.onAdded;
    this.active = undefined; // group name, null = all closed, undefined = not chosen yet
    this.expanded = {};
    this.data = null;
    this.result = null;
    this.viewed = '';
    var self = this;
    el.addEventListener('click', function (e) { self.click(e); });
  }

  Tray.prototype.update = async function (cart) {
    if (!cart.items.length) store('remove', DISMISS_KEY + '-' + this.mode);
    var data = this.data || (this.data = await loadData());
    var cfg = data && data.c;
    var show = !!(data && cfg && data.g && data.g.length);
    if (show && this.mode === 'product' && !cfg.product) show = false;
    if (show && this.mode === 'cart' && !cfg.cartpage) show = false;
    var result = show ? compute(data, cart) : null;
    if (!result || !result.groups.length) { this.el.hidden = true; this.el.innerHTML = ''; this.result = null; return; }
    if (this.mode !== 'product' && store('get', DISMISS_KEY + '-' + this.mode) === result.signature) { this.el.hidden = true; this.el.innerHTML = ''; return; }
    this.result = result;
    var names = result.groups.map(function (g) { return g.name; });
    if (this.active === undefined || (this.active !== null && names.indexOf(this.active) === -1)) {
      var first = this.mode === 'product' && !cfg.popen ? null : result.groups.filter(function (g) { return !g.collapsed; })[0];
      this.active = first ? first.name : null;
    }
    // Same tray as the one on screen (a quantity change, a re-open): leave the DOM alone, so nothing flickers and focus stays put.
    var key = result.signature + '|' + names.join(',') + '|' + result.groups.map(function (g) { return g.items.join('.'); }).join(';') + '|' + result.box.join('.') + '|' + this.active + '|' + JSON.stringify(this.expanded);
    if (key === this.drawnKey && !this.el.hidden && this.el.firstChild) return;
    var hadFocus = this.el.contains(document.activeElement);
    this.el.hidden = false;
    this.render(cfg, result);
    this.drawnKey = key;
    if (hadFocus) {
      var target = this.el.querySelector('.addons__tab[aria-expanded="true"]') || this.el.querySelector('.addons__tab');
      if (target) target.focus();
    }
    if (this.viewed !== result.signature) {
      this.viewed = result.signature;
      track(cfg, 'kabuto_addon_view', { surface: this.mode, groups: names });
    }
  };

  Tray.prototype.render = function (cfg, result) {
    this.drawnKey = null; // anything that redraws outside update() (tabs, show more) invalidates the "unchanged" shortcut
    var self = this;
    var data = this.data;
    var uid = 'addons-' + this.mode;
    var html = '<section class="addons addons--' + this.mode + '" aria-label="' + esc(cfg.heading) + '">';
    html += '<header class="addons__head"><p class="eyebrow addons__title">' + esc(cfg.heading) + '</p>';
    if (this.mode !== 'product') html += '<button type="button" class="addons__dismiss" data-addons-dismiss>' + esc(cfg.dismiss) + '</button>';
    html += '</header>';

    if (result.box.length) {
      html += '<div class="addons__box"><span class="addons__box-label"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(cfg.box) + '</span><ul class="addons__box-items" role="list">';
      result.box.forEach(function (id) {
        var p = data.p[id];
        html += '<li class="addons__box-item">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="32" height="32" loading="lazy">' : '') + '<span>' + esc(p.t) + '</span></li>';
      });
      html += '</ul></div>';
    }

    html += '<div class="addons__tabs">';
    result.groups.forEach(function (g, i) {
      var open = self.active === g.name;
      html += '<button type="button" class="addons__tab" data-addons-tab="' + esc(g.name) + '" aria-expanded="' + open + '" aria-controls="' + uid + '-' + i + '">' + esc(g.name) + '<span class="addons__count">' + g.items.length + '</span></button>';
    });
    html += '</div>';

    result.groups.forEach(function (g, i) {
      var open = self.active === g.name;
      var all = !!self.expanded[g.name];
      var shown = all ? g.items : g.items.slice(0, g.limit || 3);
      html += '<div class="addons__panel" id="' + uid + '-' + i + '"' + (open ? '' : ' hidden') + '>';
      if (g.note) html += '<p class="addons__note">' + esc(g.note) + '</p>';
      html += '<ul class="addons__list" role="list">';
      shown.forEach(function (id) { html += self.card(cfg, data.p[id], id, g.name); });
      html += '</ul>';
      if (g.items.length > shown.length) {
        html += '<button type="button" class="addons__more" data-addons-more="' + esc(g.name) + '">' + esc(cfg.all.replace('{count}', String(g.items.length))) + '</button>';
      } else if (all && g.items.length > (g.limit || 3)) {
        html += '<button type="button" class="addons__more" data-addons-less="' + esc(g.name) + '">Show fewer</button>';
      }
      if (g.url && all) html += '<a class="addons__shop" href="' + esc(g.url) + '">Shop all ' + esc(g.name.toLowerCase()) + '</a>';
      html += '</div>';
    });

    html += '<p class="visually-hidden" role="status" aria-live="polite" data-addons-live></p>';
    html += '</section>';
    this.el.innerHTML = html;
  };

  Tray.prototype.card = function (cfg, p, id, group) {
    var read = '';
    if (cfg.ready && (p.rh || p.r)) read = '<span class="addons__ready">' + (p.rh ? cleanInline(p.rh) : esc(p.r)) + '</span>';
    var price = cfg.price ? '<span class="addons__price">' + esc(money(p.p)) + '</span>' : '';
    var action = p.o
      ? '<a class="addons__add addons__add--link" href="' + esc(p.u) + '">' + esc(cfg.opts) + '</a>'
      : '<button type="button" class="addons__add" data-addons-add="' + id + '" data-addons-group="' + esc(group) + '">' + esc(cfg.add) + '</button>';
    return '<li class="addons__card">' +
      '<a class="addons__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
      '<div class="addons__info"><a class="addons__name" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' + read + price + '</div>' +
      action + '</li>';
  };

  Tray.prototype.click = function (e) {
    var self = this;
    var tab = e.target.closest('[data-addons-tab]');
    if (tab) {
      var name = tab.getAttribute('data-addons-tab');
      this.active = this.active === name ? null : name;
      this.render(this.data.c, this.result);
      var again = this.el.querySelector('.addons__tab[data-addons-tab="' + name.replace(/"/g, '\\"') + '"]');
      if (again) again.focus();
      return;
    }
    var more = e.target.closest('[data-addons-more], [data-addons-less]');
    if (more) {
      var gname = more.getAttribute('data-addons-more') || more.getAttribute('data-addons-less');
      this.expanded[gname] = !!more.hasAttribute('data-addons-more');
      this.render(this.data.c, this.result);
      var btn = this.el.querySelector('[data-addons-more="' + gname.replace(/"/g, '\\"') + '"], [data-addons-less="' + gname.replace(/"/g, '\\"') + '"]');
      if (btn) btn.focus();
      return;
    }
    if (e.target.closest('[data-addons-dismiss]')) {
      store('set', DISMISS_KEY + '-' + this.mode, this.result.signature);
      this.el.hidden = true;
      this.el.innerHTML = '';
      return;
    }
    var add = e.target.closest('[data-addons-add]');
    if (add) this.add(add);
  };

  Tray.prototype.add = async function (btn) {
    var cfg = this.data.c;
    var id = btn.getAttribute('data-addons-add');
    var p = this.data.p[id];
    if (!p || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var body = { id: p.v, quantity: 1 };
    if (p.r) body.properties = { _readiness: p.r };
    try {
      var res = await fetch(root('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('add failed');
      track(cfg, 'kabuto_addon_add', { surface: this.mode, group: btn.getAttribute('data-addons-group'), product_id: id, handle: p.h });
      var live = this.el.querySelector('[data-addons-live]');
      if (live) live.textContent = p.t + ' added';
      document.dispatchEvent(new CustomEvent('cart-addons:added', { detail: { product_id: id, mode: this.mode } }));
      if (this.onAdded) await this.onAdded(p);
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = 'Couldn’t add, tap to retry';
      setTimeout(function () { btn.textContent = label; }, 2500);
    }
  };

  // ---- hosts ------------------------------------------------------------------------------------------------
  var API = {
    mount: function (el, opts) { return new Tray(el, opts || {}); },
    compute: compute
  };
  window.KabutoAddons = API;

  async function fetchCart() {
    var res = await fetch(root('cart.js'));
    return res.json();
  }

  function autoMount() {
    var cartHost = document.querySelector('[data-addons="cart"]');
    if (cartHost) {
      var cartTray = new Tray(cartHost, { mode: 'cart', onAdded: function () { window.location.reload(); } });
      fetchCart().then(function (cart) { return cartTray.update(cart); });
    }
    var productHost = document.querySelector('[data-addons="product"]');
    if (productHost) {
      var pid = Number(productHost.getAttribute('data-product-id'));
      var productTray;
      var apply = function (cart) { return productTray.update({ items: [{ product_id: pid }], also: cart.items }); };
      var refresh = async function () { await apply(await fetchCart()); };
      productTray = new Tray(productHost, {
        mode: 'product',
        onAdded: async function () {
          await refresh();
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }
      });
      // The tray sits below the fold: read the cart once the page has settled so the request never competes with the first paint.
      var later = function () { return window.requestIdleCallback ? window.requestIdleCallback(refresh, { timeout: 3000 }) : setTimeout(refresh, 1200); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
      // The drawer announces the cart it just drew: no second cart.js request.
      document.addEventListener('cart-drawer:opened', function (e) {
        var cart = e.detail && e.detail.cart;
        if (cart && cart.items) apply(cart); else refresh();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount);
  else autoMount();
})();
